module.exports = __webpack_public_path__ + "img/active-13.b0d87e6c.svg";